import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {DelaisTraitementListPage} from './DelaisTraitementListPage'
import {DelaisTraitementPage} from './DelaisTraitementPage'

const DelaisTraitementWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Paramètres',
                  path: '#',
                  isSeparator: false,
                  isActive: true,
                }
              ]}>Délais traitement</PageTitle>
              <DelaisTraitementListPage/>
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Délais traitement', path: '/delais-traitement', isSeparator: false, isActive: true },
              ]}>Création</PageTitle>
              <DelaisTraitementPage/>
            </>
          }
        />
        <Route
          path='/:delaisTraitementId/modifier'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Délais traitement', path: '/delais-traitement', isSeparator: false, isActive: true },
              ]}>Modification</PageTitle>
              <DelaisTraitementPage/>
            </>
          }
        />
        <Route index element={<Navigate to='/delais-traitement/liste'/>}/>
      </Routes>
    </>
  )
}

export {DelaisTraitementWrapper}
